import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Megaphone, X } from "lucide-react";
import api from "../lib/api";

const KEY = "dk_banner_dismissed";

export function LaunchBanner() {
  const [b, setB] = useState(null);
  useEffect(() => {
    if (typeof window === "undefined") return;
    api.get("/site-banner").then((r) => {
      const d = r.data;
      if (d?.enabled && localStorage.getItem(KEY) !== String(d.version)) setB(d);
    }).catch(() => {});
  }, []);
  if (!b) return null;
  const dismiss = () => { localStorage.setItem(KEY, String(b.version)); setB(null); };
  return (
    <section className="bg-[#d6aa43] text-[#0d1724] border-b border-[#0d1724]/10" data-testid="launch-banner" role="region" aria-label="Announcement">
      <div className="dk-container py-4 md:py-5 flex flex-col md:flex-row md:items-center gap-3 md:gap-6">
        <div className="flex items-start gap-3 flex-1 min-w-0">
          <span className="shrink-0 w-10 h-10 rounded-full bg-[#155e3f] text-white flex items-center justify-center"><Megaphone size={18} /></span>
          <div className="min-w-0">
            {b.kicker && <div className="text-[10px] uppercase tracking-[0.25em] font-bold text-[#0d1724]/80" data-testid="launch-banner-kicker">{b.kicker}</div>}
            <h2 className="font-serif text-base md:text-lg font-bold leading-snug" data-testid="launch-banner-title">{b.title}</h2>
            {b.text && <p className="text-sm text-[#0d1724]/85 mt-0.5" data-testid="launch-banner-text">{b.text}</p>}
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-2 md:justify-end">
          {(b.links || []).map((l) => (l.url.startsWith("http")
            ? <a key={l.url} href={l.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 rounded-full bg-[#155e3f] text-white px-4 py-2 text-xs font-bold hover:bg-[#0f4a32] transition-colors" data-testid={`launch-banner-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{l.label} <ArrowRight size={12} /></a>
            : <Link key={l.url} to={l.url} className="inline-flex items-center gap-1 rounded-full bg-[#155e3f] text-white px-4 py-2 text-xs font-bold hover:bg-[#0f4a32] transition-colors" data-testid={`launch-banner-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{l.label} <ArrowRight size={12} /></Link>))}
          <button onClick={dismiss} aria-label="Dismiss announcement" className="ml-1 w-9 h-9 rounded-full border border-[#0d1724]/20 flex items-center justify-center hover:bg-[#0f4a32]/10 transition-colors" data-testid="launch-banner-dismiss"><X size={16} /></button>
        </div>
      </div>
    </section>
  );
}
